<script lang="ts" setup>
import './modal-payment.scss';
import { useModalsStore } from '@/stores/modals';
import { useAlertsStore } from '@/stores/alerts';
import { computed, onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import config from '@/config';
import { usePurchaseStore } from '../../../stores/purchase';
import { submitPayment, finishPaySafePayment } from '@/api/client/client_accounts.buy';
import { loadExternalScript, openTab } from '../../../utils';
import { useUserStore } from '@/stores/user';
import { useMatomo } from '@/composables/useMatomo';
import filters from '@/filters';
const { updateCart, getCurrentAmount, clearCart, getListProviderIssuers } = usePurchaseStore();

const { packages, cart, getMethods, payment_methods } = storeToRefs(usePurchaseStore());
const { getBonusAmount  } = usePurchaseStore();
const { toggleModal, closeModal } = useModalsStore();
const { openMessage } = useAlertsStore();
const router = useRouter();
const redirectUrl = ref('');
const userStore = useUserStore();
const { trackEvent, trackGoal } = useMatomo();

let selectedPack = ref(4);
let paymentDisabled = ref(true);
let selectedPayment = ref('');
let issuer = ref(undefined);

const sortPackages = computed(() => {
    let promo = packages.value.some(obj => obj.id === 0);
    let pack = promo ? packages.value.slice() : packages.value.slice().reverse();
    return pack;
});

const credits = computed(() => {
    return cart.value.reduce((calc, obj) => {
        return calc + obj.quantity * obj.amount;
    }, 0);
});

const canBuy = computed(() => {
    return credits.value === 0 || selectedPayment.value === '' ? false : true;
});

onMounted(() =>{
    if (!window.paysafeScriptLoaded) {
        loadExternalScript('https://hosted.paysafe.com/js/v1/latest/paysafe.min.js').onload = () => {
            window.paysafeScriptLoaded = true;
        };
        //also load checkout for other payment methods
        loadExternalScript('https://hosted.paysafe.com/checkout/v2/paysafe.checkout.min.js').onload = () => {
            window.paysafeScriptLoaded = true;
        };
    } 

    selectPackage(selectedPack.value);
})

function selectPackage(id: number) {
    selectedPack.value = id;

    let packageSelected = packages.value.find(obj => obj.id === selectedPack.value);
    if (!packageSelected) {
        return;
    }

    clearCart();
    updateCart(packageSelected.id, 1);
}

function selectPayment(method: string) {
    if(method === selectedPayment.value){ return; }
    selectedPayment.value = method;
    trackEvent('Payment', 'paymentMethodSelected', method);
    // Check if issuersList excist
    paymentDisabled.value = !getListProviderIssuers.includes(selectedPayment.value);
}

async function issuerChange(is: any){
    issuer.value = (is.target as any).value;
    paymentDisabled.value = issuer.value === 'undefined' ? false : true;
}

async function submitPaysafe() {
    let packageSelected = packages.value.find(obj => obj.id === selectedPack.value);
    if (!packageSelected) {
        throw `No package selected!`;
    }

    trackEvent('Paysafe', 'Initiate Transaction', `Total: ${+packageSelected.price}`);
    return toggleModal('paysafe')
    //or checkout page...
}

async function doPayment() {
    if (selectedPayment.value === 'paysafe2/CREDITCARD') {
        return submitPaysafe();
    }
    
    //fill iframe
    let packageSelected = packages.value.find(obj => obj.id === selectedPack.value);
    if (!packageSelected) {
        return;
    }

    trackEvent('Payment', 'requestTransaction', `Total: ${+packageSelected.price}`);
    paymentDisabled.value = false;
    
    const { error, result } = await submitPayment(selectedPayment.value.replace("paysafe2", "paysafe"), +packageSelected.price, 0, issuer.value);

    if (error || !result) {
        paymentDisabled.value = true;
        trackEvent('Payment', 'failedTransaction', 'No connection or API Error');
        throw 'No connection to payment provider! or no correct api results';
    }

    redirectUrl.value = result.redirectURL;
    const windowPayment = openTab(redirectUrl.value, 'width=830,height=630');
    trackEvent('Payment', 'requestPaymentProvider', selectedPayment.value, filters.exchangeAmount(+packageSelected.price) / 100);
    
    const timer = setInterval(async () => { 
        if (windowPayment && windowPayment.closed) {       
            clearInterval(timer);
            closeModal('payment');  
        }
    }, 1000);

    return windowPayment;
}


</script>

<template src="./modal-payment.html"></template>